import React, { useCallback, useEffect } from 'react';

import Select from 'react-select';
import lodash from 'lodash';

const withOptionsSelectValueInit = (options, defaultValue) => {
   return ({
      className: propsClassName = '',
      value,
      ...props
   }) => {
      // The value of this select component must always be an object, besides the case when the value is initially a
      // string

      // If the value is a string then find the option with this value
      // Usage: filter initialization. A Select component may have just the value stored in the queryString

      useEffect(() => {
         if (value !== undefined && (lodash.isString(value) || lodash.isNumber(value))) {
            const selectedOption = options.find((option) => value === option.value);
            if (selectedOption !== undefined) {
               props.onChange(selectedOption);
            }
         }
      }, [value]);

      const handleChange = useCallback((selectedOption) => {
         if (props.onChange) {
            props.onChange(selectedOption);
         }
      }, [props.onChange]);

      return (
         <Select
            defaultValue={defaultValue}
            value={value}
            className={`react-select-container ${ propsClassName }`}
            classNamePrefix='react-select'
            onChange={handleChange}
            options={options}
         />
      );
   };
};

export default withOptionsSelectValueInit;
